import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	title: {
		id: 'eoc.heartbeats.list.no-search-result.empty-state.title.no-translate',
		defaultMessage: `We couldn’t find what you’re looking for`,
		description: `The text will be displayed in no search result component's header.`,
	},
	description: {
		id: 'eoc.heartbeats.list.no-search-result.empty-state.description.no-translate',
		defaultMessage: 'Try a different name or double-check your filters.',
		description: `The text will be displayed in no search result component's description.`,
	},
});

export default messages;
